import React from 'react';
import { Avatar } from '../Icon.assets/Avatar';
import { IconRoot } from '../IconRoot';
export var IconAvatar = function IconAvatar(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 's' : _ref$size,
      color = _ref.color,
      className = _ref.className;
  return /*#__PURE__*/React.createElement(IconRoot, {
    className: className,
    size: size,
    color: color,
    icon: Avatar
  });
};